import React from "react";
import { Link } from "react-router-dom";
import { useComponentTranslation } from "@/services/i18n";
import { FiClock, FiArrowRight } from "react-icons/fi";
import { TRAININGS } from "./data";

const translations = {
  en: {
    training: {
      title: "Training Modules",
      subtitle: "Complete these modules to boost your skills and career",
      duration: "Duration",
      level: "Level",
      view_module: "View module",
      modules_count: "modules available",
      what_you_learn: "What you'll learn",
    },
  },
  fr: {
    training: {
      title: "Modules de formation",
      subtitle: "Validez ces modules pour développer vos compétences et booster votre carrière",
      duration: "Durée",
      level: "Niveau",
      view_module: "Voir le module",
      modules_count: "modules disponibles",
      what_you_learn: "Au programme",
    },
  },
};

export default function TrainingList() {
  const { t } = useComponentTranslation(translations);

  return (
    <div className="">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">{t("training.title")}</h1>
        <p className="text-sm text-gray-500 mt-1">{TRAININGS.length} {t("training.modules_count")}</p>
        <p className="text-gray-600 mt-3 max-w-2xl">{t("training.subtitle")}</p>
      </div>

      {/* Training Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {TRAININGS.map((training) => (
          <Link
            key={training.id}
            to={`/candidate/training/${training.id}`}
            className="group relative bg-white rounded-xl border border-gray-200 hover:border-transparent hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
          >
            {/* Gradient accent bar */}
            <div 
              className="absolute top-0 left-0 right-0 h-1.5"
              style={{ background: `linear-gradient(90deg, ${training.gradientFrom} 0%, ${training.gradientTo} 100%)` }}
            />
            
            <div className="p-4 flex flex-col flex-1">
              {/* Title */}
              <h3 className="text-sm font-semibold text-gray-900 group-hover:text-blue-600 transition-colors mb-2 line-clamp-2">
                {training.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-gray-500 leading-relaxed mb-3 line-clamp-3 flex-1">
                {training.shortDescription}
              </p>

              {/* Meta info */}
              <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                <div className="flex items-center gap-1">
                  <FiClock className="w-3 h-3" />
                  <span>{training.duration}</span>
                </div>
                <span>•</span>
                <span>{training.level}</span>
              </div>

              {/* CTA */}
              <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                <span 
                  className="text-xs font-medium"
                  style={{ color: training.bgColor }}
                >
                  {t("training.view_module")}
                </span>
                <FiArrowRight 
                  className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform"
                  style={{ color: training.bgColor }}
                />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
